import { useMutation } from '@tanstack/react-query';

import type { DeleteEmployeeScheduleArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: DeleteEmployeeScheduleArgs) => {
  return employeeService.deleteEmployeeSchedule(data);
};

export const useEmployeeDeletePartnerMutation = () => {
  return useMutation<unknown, unknown, DeleteEmployeeScheduleArgs>(mutationFn);
};
